import React from "react";
import LoginBannerStyle from "../styles/LoginBannerStyle";
import img from "../assets/images/login.png";
import RaksLogo from "./raksLogo";

export const LoginBanner = ({
  appName,
  appDesc,
}: {
  appName?: string;
  appDesc?: string;
}) => {
  return (
    <LoginBannerStyle>
      <RaksLogo appName={appName} appDesc={appDesc} />
      <img src={img} alt="logo" width={600} height={600} />
      </LoginBannerStyle>
  );
};

export default LoginBanner;
